const _ = require("lodash");
const moment = require("moment");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const AT = require("../../vault/ActionTypes");
const withVaultDispatch = require("../../hoc/withVaultDispatch");
const withBundleLoading = require("../../hoc/withBundleLoading");
const withVaultUpdate = require("../../hoc/withVaultUpdate");
const GlobalFlags = require("../../util/GlobalFlags");
const {FLAGS, FLAG_OPTIONS, FLAG_OPTIONS_SCHEMA} = GlobalFlags;

const {AnimatedCharacter, beastStyles} = require("../AnimatedCharacter");
const DevNavSection = require("../DevNavSection");
const DevTimeTracking = require("../DevTimeTracking");
const DevNavigationPages = require("./DevNavigationPages");
const {DevAccountTools} = require("./DevAccountTools");
const {DevFlagTools} = require("./DevFlagTools");

const styles = require("../styles/DevPanels.css");
const {
	logVaultActionHistory,
	logVaultActionTypes,
	logVaultState,
	logCurrentResults,
} = require("../../vault/loggers");

const progressStatuses = {
	inProgress: "Working... ⏳",
	complete: "Complete ✅",
	failed: "Failed 😭",
};

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withBundleLoading(Component);
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component, function(props, vaultState) {
		return {
			userID: _.get(vaultState, "user.userID"),
			devWindowsAreHidden: vaultState.devWindowsAreHidden,
			vaultState,
		};
	});
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "DevNavigation",

		propTypes: {
			onFlagChange: PT.func,

			// Injected by HOCs
			userID: PT.number,
			devWindowsAreHidden: PT.bool,
			vaultState: PT.object,
			dispatch: PT.func.isRequired,
			requireOrLoadBundle: PT.func.isRequired,
		},

		getInitialState: function() {
			return {
				closed: true,
				expandedFlagSuboptions: {},
				trainerDataImportProgress: null,
				trainerDataImportRequestedUserID: "",
				trainerDataImportInvalidUserID: false,
				trainerDataImportRequestedClassID: "",
				trainerDataImportInvalidClassID: false,
				studentSnapshotUserID: "",
				studentSnapshotInvalidUserID: false,
			};
		},

		vaultEvents: {
			trainerDataImportComplete: function() {
				this.setState({trainerDataImportProgress: progressStatuses.complete});
			},
			trainerDataImportFailed: function() {
				this.setState({trainerDataImportProgress: progressStatuses.failed});
			},
		},

		onUnlockBlocksInCurrentChapter: function() {
			this.props.dispatch({
				type: AT.DEBUG_UNLOCK_BLOCKS_IN_CURRENT_CHAPTER,
			});
		},

		onHideAll: function() {
			this.props.dispatch({type: AT.DEBUG_HIDE_DEV_WINDOWS});
		},

		/* Change the type below to dispatch a different vault action */
		dispatchVaultAction: function() {
			this.props.dispatch({
				type: AT.TRIGGER_DEV_ENDPOINT,
			});
		},

		setLevel: function(xpLevel) {
			const validLevel = /^[1-9]\d+\.?\d*$/.test;
			if (!validLevel) return;
			const newXP = Math.floor(25 * xpLevel ** 2);
			this.props.dispatch({
				type: AT.DEBUG_SET_XP_REQUEST,
				newXPTotal: newXP,
			});
		},

		handleNumericKeyPress: function(evt) {
			const charCode = evt.which ? evt.which : evt.keyCode;

			// Allow backspace (8), delete (46), tab (9), and arrow keys (37 for left, 39 for right)
			if (
				charCode === 8 || // Backspace
				charCode === 9 || // Tab
				charCode === 37 || // Left arrow
				charCode === 39 || // Right arrow
				charCode === 46 // Delete
			) {
				return;
			}

			// Prevent any non-numeric characters
			const notInNumRow = charCode < 48 || charCode > 57;
			const notInNumpad = charCode < 96 || charCode > 105;
			if (notInNumRow && notInNumpad) {
				evt.preventDefault();
			}
		},

		handleTrainerDataImportRequestedUserIdChange: function(evt) {
			const isValid = evt.target.value === "" || /^\d+$/.test(evt.target.value);
			this.setState({
				trainerDataImportInvalidUserID: !isValid,
				trainerDataImportRequestedUserID: evt.target.value,
				trainerDataImportProgress: null,
			});
		},

		handleStudentSnapshotUserIdChange: function(evt) {
			const isValid = evt.target.value === "" || /^\d+$/.test(evt.target.value);
			this.setState({
				studentSnapshotInvalidUserID: !isValid,
				studentSnapshotUserID: evt.target.value,
				studentSnapshotProgress: null,
			});
		},

		handleTrainerDataImportRequestedClassIdChange: function(evt) {
			const isValid = evt.target.value === "" || /^\d+$/.test(evt.target.value);
			this.setState({
				trainerDataImportInvalidClassID: !isValid,
				trainerDataImportRequestedClassID: evt.target.value,
				trainerDataImportProgress: null,
			});
		},

		loadTrainerData: function(loadType) {
			this.setState({trainerDataImportProgress: progressStatuses.inProgress});
			if (loadType === "current") {
				this.props.dispatch({
					type: AT.DEBUG_IMPORT_TRAINER_DATA_FOR_USER_REQUEST,
					userID: this.props.userID,
				});
			} else if (loadType === "user") {
				this.props.dispatch({
					type: AT.DEBUG_IMPORT_TRAINER_DATA_FOR_USER_REQUEST,
					userID: parseInt(this.state.trainerDataImportRequestedUserID),
				});
			} else if (loadType === "class") {
				this.props.dispatch({
					type: AT.DEBUG_IMPORT_TRAINER_DATA_FOR_CLASS_REQUEST,
					classID: parseInt(this.state.trainerDataImportRequestedClassID),
				});
			}
		},

		resetPermissions: function() {
			fetch("/api/admin/permissions/resetPermissions", {
				method: "POST",
			})
				.then(response => response.json())
				.then(data => {
					// eslint-disable-next-line no-alert
					alert("Permissions reset!");
				})
				.catch(error => {
					// eslint-disable-next-line no-alert
					alert("Error resetting permissions:", error);
				});
		},

		generateStudentSnapshot: function(loadType) {
			this.setState({studentSnapshotProgress: progressStatuses.inProgress});
			const requestedUserID =
				loadType === "user"
					? parseInt(this.state.studentSnapshotUserID)
					: this.props.userID;
			fetch("/api/user/studentSnapshot", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({userID: requestedUserID}),
			})
				.then(response => response.json())
				.then(data => {
					// Convert the JSON response into a blob
					const blob = new Blob([JSON.stringify(data)], {
						type: "application/json",
					});

					// Create a download link
					const url = URL.createObjectURL(blob);
					const a = document.createElement("a");
					a.href = url;
					a.download = `student_snapshot_${requestedUserID}_${moment
						.utc()
						.valueOf()}.json`;

					// Append to the document and trigger the download
					document.body.appendChild(a);
					a.click();

					// Clean up the DOM
					a.remove();
					URL.revokeObjectURL(url);
					this.setState({studentSnapshotProgress: progressStatuses.complete});
				})
				.catch(error => {
					console.error("Error fetching student snapshot:", error); // eslint-disable-line no-console
					this.setState({studentSnapshotProgress: progressStatuses.failed});
				});
		},

		resetLevelNotification: function() {
			this.props.dispatch({
				type: AT.DEBUG_RESET_LEVEL_NOTIFICATION_REQUEST,
			});
		},

		renderFlagSuboption: function(flagOptions, suboptionScheme) {
			const {name, label, type, help} = suboptionScheme;
			const value = flagOptions[name];
			const onFlagChange = this.props.onFlagChange || (() => {});
			const onSetOption = evt => {
				let newVal = value;
				if (type === "boolean") {
					newVal = !!evt.target.checked;
				}
				if (type === "number") {
					newVal = Number(evt.target.value);
				}
				if (type === "enum") {
					newVal = evt.target.value;
				}
				if (type === "color") {
					newVal = evt.target.value;
				}
				if (type === "text") {
					newVal = evt.target.value;
				}
				flagOptions[name] = newVal;
				onFlagChange();
				this.forceUpdate();
			};
			const renderControl = () => {
				if (type === "boolean") {
					return (
						<input
							type="checkbox"
							checked={flagOptions[name]}
							onChange={onSetOption}
						/>
					);
				} else if (["number", "color", "text"].includes(type)) {
					return (
						<input
							type={type}
							value={flagOptions[name]}
							onChange={onSetOption}
						/>
					);
				} else if (type === "enum") {
					return (
						<select onChange={onSetOption} defaultValue={value}>
							{suboptionScheme.enum.map(val => (
								<option value={val} key={val}>
									{val}
								</option>
							))}
						</select>
					);
				} else {
					return <div>[Unknown Type "{type}"]</div>;
				}
			};
			const renderHelp = () => {
				if (!help) {
					return null;
				}
				return (
					<>
						{" "}
						<div
							className={styles.flagSuboptionHelpContainer}
							onClick={evt => evt.stopPropagation()}
						>
							<span className={styles.flagSuboptionHelpIcon}>i</span>
							<div className={styles.flagSuboptionHelp}>{help}</div>
						</div>
					</>
				);
			};
			if (type === "group") {
				return (
					<details key={name}>
						<summary className={styles.flagSuboptionGroupHandle}>
							{label || name}
							{renderHelp()}
							<span className={styles.flagSuboptionGroupCount}>
								{" ("}
								{suboptionScheme.items.length}
								{")"}
							</span>
						</summary>
						{this.renderFlagSuboptions(
							suboptionScheme.items,
							flagOptions[name]
						)}
					</details>
				);
			} else {
				return (
					<div key={name} className={styles.flagSuboptionItem}>
						{label || name}
						{renderHelp()}
						{": "}
						{renderControl()}
					</div>
				);
			}
		},

		renderFlagSuboptions: function(flagSchema, flagOptions) {
			return (
				<div className={styles.flagSuboptionContainer}>
					{flagSchema.map(suboptionScheme =>
						this.renderFlagSuboption(flagOptions, suboptionScheme)
					)}
				</div>
			);
		},

		renderFlags: function() {
			const onFlagChange = this.props.onFlagChange || (() => {});

			const onSetFlag = (evt, name) => {
				const newValue = !!evt.target.checked;
				GlobalFlags.setFlagAndSave(name, newValue);
				onFlagChange();
				this.forceUpdate();
			};

			const onSetDev = () => {
				GlobalFlags.resetAllSaved();
				GlobalFlags.setDevelopmentEnv();
				onFlagChange();
				this.forceUpdate();
			};

			const onSetProd = () => {
				GlobalFlags.resetAllSaved();
				GlobalFlags.setProductionEnv();
				onFlagChange();
				this.forceUpdate();
			};

			const toggleSuboptions = (evt, name) => {
				const stateDiff = {
					expandedFlagSuboptions: {
						...this.state.expandedFlagSuboptions,
						[name]: !this.state.expandedFlagSuboptions[name],
					},
				};
				this.setState(stateDiff);
			};

			const flagsArray = GlobalFlags.getList().map(name => {
				const checkProps = {
					type: "checkbox",
					checked: FLAGS[name],
					onChange: evt => onSetFlag(evt, name),
				};
				const showOptions =
					checkProps.checked && this.state.expandedFlagSuboptions[name];
				return (
					<div key={name}>
						<label className={styles.label}>
							<input {...checkProps} /> {name}
						</label>{" "}
						{checkProps.checked && FLAG_OPTIONS[name] && (
							<span
								onClick={evt => toggleSuboptions(evt, name)}
								className={styles.flagSuboptionToggle}
							>
								({showOptions ? "hide" : "show"} options)
							</span>
						)}
						{showOptions &&
							this.renderFlagSuboptions(
								FLAG_OPTIONS_SCHEMA[name],
								FLAG_OPTIONS[name]
							)}
					</div>
				);
			});

			return (
				<DevNavSection heading="Flags">
					<div>(Some may need refresh)</div>
					<div>
						<button onClick={onSetDev} className={styles.button}>
							Use dev values
						</button>
					</div>
					<div>
						<button onClick={onSetProd} className={styles.button}>
							Use prod values
						</button>
					</div>
					{flagsArray}
				</DevNavSection>
			);
		},

		renderDevProblems: function() {
			const DevProblemList = this.props.requireOrLoadBundle(
				"trainer",
				"DevProblemList"
			);
			if (!DevProblemList) {
				return <div>Loading...</div>;
			} else {
				return <DevProblemList />;
			}
		},

		renderTimeTracking: function() {
			return (
				<DevNavSection heading="Time Tracking">
					<DevTimeTracking />
				</DevNavSection>
			);
		},

		renderDebugTools: function() {
			return (
				<DevNavSection heading="Debug Tools">
					<div>
						<button
							title="Reset permissions"
							className={styles.button}
							onClick={() => {
								this.resetPermissions();
							}}
						>
							Reset permissions
						</button>
					</div>
					<div>
						<button
							title="Log current vault state to the browser console"
							className={styles.button}
							onClick={() => logVaultState(this.props.vaultState)}
						>
							Log Vault State
						</button>
						<div id="vaultStateLoggingNotification" />
					</div>
					<div>
						<button
							title="Log current list of actions dispatch to the vault to the browser console"
							className={styles.button}
							onClick={logVaultActionHistory}
						>
							Log Vault Actions
						</button>
						<div id="vaultActionHistoryLoggingNotification" />
					</div>
					<div>
						<button
							title="Log mapping of action type keys to their values in the action objects to the browser console"
							className={styles.button}
							onClick={logVaultActionTypes}
						>
							Log Vault Action Types
						</button>
						<div id="vaultActionMappingLoggingNotification" />
					</div>
					<div>
						<button
							className={styles.button}
							onClick={() => logCurrentResults(this.props)}
						>
							Log Current Results
						</button>
						<span id="currentResultLoggingNotification" />
					</div>
					<div className={styles.linkExt} onClick={this.dispatchVaultAction}>
						Dispatch Vault Action
					</div>
					<br />
					<label htmlFor="xpModInput">Student level (can be decimal)</label>
					<div>
						<input type="text" id="xpModInput" />
						<button
							onClick={() => {
								const xpLevel = document.getElementById("xpModInput").value;
								this.setLevel(xpLevel);
							}}
						>
							Save
						</button>
					</div>
					<br />
					<div>
						<button
							onClick={() => {
								this.resetLevelNotification();
							}}
						>
							Reset level notification
						</button>
					</div>
				</DevNavSection>
			);
		},

		renderTrainerDataImport: function() {
			const {
				trainerDataImportProgress: progress,
				trainerDataImportRequestedUserID: userID,
				trainerDataImportInvalidUserID: invalidUserID,
				trainerDataImportRequestedClassID: classID,
				trainerDataImportInvalidClassID: invalidClassID,
			} = this.state;

			const inProgress = progress === progressStatuses.inProgress;
			const errorStyles = {borderColor: "red", borderSize: "1px"};
			const userIdFieldStyles = invalidUserID ? errorStyles : {};
			const classIdFieldStyles = invalidClassID ? errorStyles : {};

			const progressArea = progress ? (
				<div>Request status: {progress}</div>
			) : (
				<br />
			);

			return (
				<DevNavSection heading="Trainer Data Loading">
					<div>
						<button
							onClick={() => {
								this.loadTrainerData("current");
							}}
							disabled={inProgress}
						>
							For current user
						</button>
					</div>
					<br />
					<div>
						userID&nbsp;
						<input
							type="number"
							min="0"
							step="1"
							value={userID}
							onChange={this.handleTrainerDataImportRequestedUserIdChange}
							disabled={inProgress}
							style={userIdFieldStyles}
						/>
						<button
							onClick={() => {
								this.loadTrainerData("user");
							}}
							disabled={invalidUserID || inProgress || userID === ""}
						>
							Go
						</button>
					</div>
					<br />
					<div>
						classID&nbsp;
						<input
							type="number"
							min="0"
							step="1"
							value={classID}
							onChange={this.handleTrainerDataImportRequestedClassIdChange}
							disabled={inProgress}
							style={classIdFieldStyles}
						/>
						<button
							onClick={() => {
								this.loadTrainerData("class");
							}}
							disabled={invalidClassID || inProgress || classID === ""}
						>
							Go
						</button>
					</div>
					<br />
					{progressArea}
				</DevNavSection>
			);
		},

		renderStudentSnapshot: function() {
			const {
				studentSnapshotProgress: progress,
				studentSnapshotUserID: userID,
				studentSnapshotInvalidUserID: invalidUserID,
			} = this.state;

			const inProgress = progress === progressStatuses.inProgress;
			const errorStyles = {borderColor: "red", borderSize: "1px"};
			const userIdFieldStyles = invalidUserID ? errorStyles : {};

			const progressArea = progress ? (
				<div>Request status: {progress}</div>
			) : (
				<br />
			);

			return (
				<DevNavSection heading="Student Snapshot">
					<div>
						<button
							onClick={() => {
								this.generateStudentSnapshot("current");
							}}
							disabled={inProgress}
						>
							Snapshot Current User
						</button>
					</div>
					<br />
					<div>
						userID&nbsp;
						<input
							type="number"
							min="0"
							step="1"
							inputMode="numeric"
							pattern="[0-9]+"
							value={userID}
							onChange={this.handleStudentSnapshotUserIdChange}
							onKeyDown={this.handleNumericKeyPress}
							disabled={inProgress}
							style={userIdFieldStyles}
						/>
					</div>
					<br />
					<div>
						<button
							onClick={() => {
								this.generateStudentSnapshot("user");
							}}
							disabled={invalidUserID || inProgress || userID === ""}
						>
							Generate Snapshot
						</button>
					</div>
					<br />
					{progressArea}
				</DevNavSection>
			);
		},

		renderTestList: function() {
			return (
				<DevNavSection heading="Unit Test Report">
					<div>
						To generate files:
						<br />
						<code>cd /var/www/ba/dev/listtests</code>
						<br />
						<code>./makeTestLists.sh</code>
						<br />
					</div>
					<br />
					<div>
						Open{" "}
						<code>
							/var/www/ba/dev/
							<br />
							listtests/test-lists/allTests.html
						</code>
						<br /> in a browser
						{/* <a
							target="_blank"
							href="file:///var/www/ba/dev/listtests/test-lists/allTests.html">
							All Tests
						</a> */}
					</div>
				</DevNavSection>
			);
		},

		renderRandomRiveAnimation: function() {
			const randomBeastStyle =
				beastStyles[Math.floor(Math.random() * beastStyles.length)];
			return (
				<AnimatedCharacter
					beastStyle={randomBeastStyle}
					className={styles.riveAnimationDemo}
				/>
			);
		},

		render: function() {
			if (this.props.devWindowsAreHidden) {
				return null;
			}

			if (this.state && this.state.closed) {
				return (
					<div id="navigation" className={styles.containerNav}>
						<div>
							<a
								className={styles.close}
								onClick={() => this.setState({closed: false})}
							>
								DEV
							</a>
						</div>
					</div>
				);
			}

			return (
				<div id="navigation" className={styles.containerNavExpanded}>
					<div>
						<a
							className={styles.close}
							onClick={() => this.setState({closed: true})}
						>
							Collapse this window
						</a>
					</div>
					<div>
						<a
							className={styles.close}
							onClick={this.onHideAll}
							title="They will come back when you refresh"
						>
							Hide ALL dev windows
						</a>
					</div>
					<div>
						<a
							className={styles.close}
							onClick={this.onUnlockBlocksInCurrentChapter}
						>
							Unlock Blocks In Chapter
						</a>
					</div>
					{this.renderFlags()}
					<DevFlagTools />
					{this.renderDevProblems()}
					<DevNavigationPages />
					{this.renderTimeTracking()}
					{this.renderDebugTools()}
					{this.renderTrainerDataImport()}
					{this.renderStudentSnapshot()}
					<DevAccountTools />
					{this.renderTestList()}
					{this.renderRandomRiveAnimation()}
				</div>
			);
		},
	})
);
